export const integrations = {
  hero: {
    heading: {
      1: 'Your',
      2: 'favorite apps',
      3: 'integrated with a single click',
    },
    description: {
      1: 'We offer a wide variety of integrations to allow you to focus on what you do best, without a hassle.',
      2: 'Our integrations make everything work together effortlessly, so you can focus on growing your business, not managing tech. Quick setup, smooth experience, and no hassle.'
    }
  },
  cards: {
    card_1: {
      title: 'Pick your integration',
      text: 'Choose your integration from our marketplace',
      button: 'Show marketplace',
      img_alt: ''
    },
    card_2: {
      title: 'Follow the guide',
      text: 'We provide you with the steps you need to take to ensure a smooth integration process',
      button: '',
      img_alt: ''
    },
    card_3: {
      title: 'Activate the integration',
      text: 'Activate the integration within the Bistroo manager app and start communicating data.',
      button: '',
      img_alt: ''
    },
    card_4: {
      title: 'Questions?',
      text: ' If you have any questions or would like to have a second pair of eyes to verify your integration, do not hestitate to contact us.',
      button: '',
      img_alt: ''
    },
    card_5: {
      title: 'You are ready to go!',
      text: 'With these steps completed your software has been fully integrated.',
      button: '',
      img_alt: ''
    }
  },
  partner: {
    title: 'Want to become a partner?',
    text: {
      1: 'Sign up soon via our partner portal. Until then, feel free to',
      2: 'get in touch',
      3: 'with us.'
    }
  }
}
